/**
 * Created by Bowen on 10/20/2020.
 * Description:
 * Duplicated contact dialog
 *
 * ------ maintenance history ------
 */


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { DuplicatedContactDialogComponent } from './duplicated-contact-dialog.component';
import { DuplicatedItemComponent } from './duplicated-item/duplicated-item.component';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
    ],
    declarations: [
        DuplicatedContactDialogComponent,
        DuplicatedItemComponent,
    ],
    exports: [
        DuplicatedContactDialogComponent,
    ],
    providers: []
})
export class DuplicateContactDialogModule {
}
